// Sample subscriptions and order history for a contact with more than one club membership

export type ContactSubscriptionStatus = 'Active' | 'Paused' | 'Cancelled';

export interface ContactSubscription {
  id: string;
  club: string;
  plan: string; // e.g. "6 Bottles Every 2 Months"
  frequency: string; // e.g. "Every 2 months"
  intervalMonths: number;
  cadenceLabel: string; // short form for summaries, e.g. "6 bottles every 2 months"
  bottles: number;
  price: number;
  status: ContactSubscriptionStatus;
  nextBilling: string | null; // YYYY-MM-DD
  skips12m: number;
  pauses12m: number;
  cancelledOn?: string; // YYYY-MM-DD
  cancelReason?: string;
}

export const contactSubscriptions: ContactSubscription[] = [{
  id: 'SUB-23144',
  club: 'Premium Club',
  plan: '6 Bottles Every 2 Months',
  frequency: 'Every 2 months',
  intervalMonths: 2,
  cadenceLabel: '6 bottles every 2 months',
  bottles: 6,
  price: 289,
  status: 'Active',
  nextBilling: '2026-12-05',
  skips12m: 2,
  pauses12m: 1
}, {
  id: 'SUB-23138',
  club: 'Reds Club',
  plan: '12 Bottles Quarterly',
  frequency: 'Quarterly',
  intervalMonths: 3,
  cadenceLabel: '12 bottles quarterly',
  bottles: 12,
  price: 540,
  status: 'Active',
  nextBilling: '2027-01-20',
  skips12m: 1,
  pauses12m: 0
}, {
  id: 'SUB-22981',
  club: 'Whites Club',
  plan: '6 Bottles Monthly',
  frequency: 'Monthly',
  intervalMonths: 1,
  cadenceLabel: '6 bottles monthly',
  bottles: 6,
  price: 228,
  status: 'Cancelled',
  nextBilling: null,
  skips12m: 0,
  pauses12m: 0,
  cancelledOn: '2025-03-14',
  cancelReason: 'Too much white wine'
}];
